import { render, staticRenderFns } from "./SalesBySection.vue?vue&type=template&id=f6471a0e&scoped=true"
import script from "./SalesBySection.vue?vue&type=script&lang=js"
export * from "./SalesBySection.vue?vue&type=script&lang=js"
import style0 from "./SalesBySection.vue?vue&type=style&index=0&id=f6471a0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6471a0e",
  null
  
)

export default component.exports